import {
  inputAllData
} from '@/api/oli_api'

const state = {
  hxDate: '',
  allPs: false,
  waitHxList: [],
  canHxPsjhList: [],
  hxJxc: null,
  loadingHxJxc: false,
  loadingCanHxPsjh: false,
  loadingSysHx: false,
  loadingUserHx: false
}

const getters = {
  loadingHxJxc: state => state.loadingHxJxc,
  loadingCanHxPsjh: state => state.loadingCanHxPsjh,
  loadingSysHx: state => state.loadingSysHx,
  loadingUserHx: state => state.loadingUserHx,
  hxJxc: state => state.hxJxc,
  hxDate: state => state.hxDate,
  allPs: state => state.allPs,
  waitHxList: state => state.waitHxList,
  canHxPsjhList: state => state.canHxPsjhList
}

const actions = {
  loadWaitHx ({ commit, dispatch, getters }) {
    commit('setLoadingHxJxc', true)
    dispatch('setWaitHxList', [])
    // 获取未核销数据
    let parm = {
      action: 'get_whx_jxc',
      data: {
        date: getters.hxDate,
        allPs: getters.allPs ? 1 : 0
      }
    }
    inputAllData(parm).then((data) => {
      data.forEach((item) => {
        item['核销状态'] = item['核销'] ? '完成' : '待核销'
      })
      dispatch('setWaitHxList', data)
      commit('setLoadingHxJxc', false)
    })
  },
  sysHxjxc ({ commit, dispatch, getters }, data) {
    if (getters.loadingSysHx) {
      return
    }
    commit('setLoadingSysHxh', true)
    // 系统核销
    let parm = {
      action: 'hexiao_jxc',
      data: {
        date: getters.hxDate,
        allPs: getters.allPs ? 1 : 0
      }
    }
    inputAllData(parm).then((data) => {
      dispatch('showNoticeMsg', {
        type: 'success',
        title: '系统提示',
        message: '该日数据已核销！'
      })
      commit('setLoadingSysHxh', false)
      dispatch('loadWaitHx')
    })
  },
  userHxjxc ({ commit, dispatch, getters }, data) {
    if (getters.loadingUserHx) {
      return
    }
    commit('setLoadingUserHx', true)
    // 手动核销
    let parm = {
      action: 'user_hexiao_jxc',
      data: {
        jxc: getters.hxJxc,
        psjh: data
      }
    }
    inputAllData(parm).then((data) => {
      commit('setLoadingUserHx', false)
      dispatch('loadWaitHx')
    })
  },
  getCanHxPsjhList ({ commit, dispatch, getters }) {
    commit('setLoadingCanHxPsjh', true)
    dispatch('setCanHxPsjhList', [])
    // 获取可用核销配送计划
    let parm = {
      action: 'get_canhx_psjh',
      data: {
        date: getters.hxDate,
        jxc: getters.hxJxc
      }
    }
    inputAllData(parm).then((data) => {
      dispatch('setCanHxPsjhList', data)
      commit('setLoadingCanHxPsjh', false)
    })
  },
  setHxDate ({ commit }, data) {
    commit('setHxDate', data)
  },
  setUserHxJxc ({ commit, dispatch }, data) {
    commit('setUserHxJxc', data)
  },
  setAllPs ({ commit }, data) {
    commit('setAllPs', data)
  },
  setWaitHxList ({ commit }, data) {
    commit('setWaitHxList', data)
  },
  setCanHxPsjhList ({ commit }, data) {
    commit('setCanHxPsjhList', data)
  }
}

const mutations = {
  setLoadingUserHx (state, data) {
    state.loadingUserHx = data
  },
  setLoadingHxJxc (state, data) {
    state.loadingHxJxc = data
  },
  setLoadingCanHxPsjh (state, data) {
    state.loadingCanHxPsjh = data
  },
  setLoadingSysHxh (state, data) {
    state.loadingSysHx = data
  },
  setUserHxJxc (state, data) {
    state.hxJxc = data
  },
  setHxDate (state, data) {
    state.hxDate = data
  },
  setAllPs (state, data) {
    state.allPs = data
  },
  setWaitHxList (state, data) {
    state.waitHxList = data
  },
  setCanHxPsjhList (state, data) {
    state.canHxPsjhList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/oil_hxchx.js